export default function UpdateUserCheckoutForm() {
    return {
        restrict: "E",
        scope: {
            formHolder: "=",
            models: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, Roles) {
            $scope.debug = false;

            // /** lookup user role  */
            // $scope.roles.forEach((role) => {
            //     if (role.id === $scope.user.primaryRole) {
            //         $scope.role = role;
            //     }
            // });
            /**
             * Submitting this form must be handled by parent
             * parent can access form state in {formHolder}
             */

            /**
             * Return role obj if
             * Shoud be capability based
             */
            $scope.userHasOneOfThesesRoles = (ids, roleId) => {
                return Roles.userHasOneOfThesesRoles(ids, roleId); // return bool
            };

            // $scope.userCan = (cap, roleId) => {
            //     return Caps.userCan(cap, roleId);
            // };

            // const res = $scope.userCan(["form-city", "form-company-cvr"], 3);
            // console.log(res);
        },
    };
}
